import React, { useEffect, useState } from "react";
import {
  Typography, Box, Card, CardContent, CardActions, Avatar,
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, List, ListItem, ListItemText, Select, MenuItem, InputLabel,
  FormControl, CircularProgress, Tooltip
} from "@mui/material";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { postDossierActionPlan, deleteActionPlan, getDossierActionPlan, getDossierTagUsersList} from "../Dossier/Network_call";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
 
const ActionPlan = ({ dossierData }) => {
  const [message, setMessage] = useState("");
  const [actionPlans, setActionPlans] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [showUserList, setShowUserList] = useState(false);
  const [taggedList, setTaggedList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(true);
 
  let dossierId = dossierData?.id;
  let Customer_External_id = dossierData?.external_id;
  let impl_id = localStorage.getItem('tag_id');

 
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const actionPlanResult = await getDossierActionPlan(dossierId);
        if (actionPlanResult.status === 200) {
          let data = actionPlanResult.data;
          if (data.error !== "Dossier Action Plan not found") {
            setActionPlans(data.actionPlans);
          }
        } else {
          console.error("Error fetching dossier Action Plan details");
        }
 
        const customerResp = await getDossierTagUsersList(impl_id);
        setUsers(customerResp.data.userListRows);

      } catch (error) {
        console.error("Failed to fetch data", error);
        toast.error("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
 
    fetchData();
  }, [dossierId]);


  useEffect(() => {

    const updateTaggedList = () => {
        const newTaggedList = users
            .filter(user => {
                const usernameToMatch = user.name.startsWith('$') ? user.email.split('@')[0] : user.name;
                return message.includes(`@${usernameToMatch}`);
            })
            .map(user => {
                const username = user.name.startsWith('$')
                    ? user.email.split('@')[0]  
                    : user.name;

                return {
                    username: username,
                    user_id: user.id,
                };
            });

        setTaggedList(newTaggedList);
    };

    updateTaggedList();
}, [message, users]);

 
  const handleOpen = () => {
    setMessage("");
    setEditIndex(null);
    setOpen(true);
    setTaggedList([]);
    setSelectedUser(null);
  };
 
  const handleClose = () => {
    setOpen(false);
  };
 
  const extractPlainText = (text, taggedList) => {
    let cleanText = text;
    taggedList.forEach(tag => {
      
      const regex = new RegExp(`@${tag.username}`, 'g');
      cleanText = cleanText.replace(regex, '').trim();
    });

    return cleanText;
  };
 
const handleSave = async () => {
  if (message.trim()) {
    const cleanMessage = extractPlainText(message, taggedList);

    const formattedTaggedList = taggedList.map((tag) => ({
      id:
        actionPlans[editIndex]?.tagged_list?.find(
          (t) => t.username === tag.username
        )?.id || undefined,
      username: tag.username,
      user_id: tag.user_id,
    }));

    let updatedPlan = {
      plan: cleanMessage,
      tagged_list: formattedTaggedList,
    };

    if (editIndex !== null && actionPlans[editIndex]) {
      updatedPlan.id = actionPlans[editIndex].id;
    }

    try {
      const result = await postDossierActionPlan(
        [updatedPlan],
        dossierId,
        Customer_External_id
      );
      if (result.status === 200) {
        fetchUpdatedActionPlans();
        toast.success("Dossier details submitted successfully");
      } else {
        toast.error("Failed to submit dossier details");
      }
    } catch (error) {
      toast.error("An error occurred while submitting the dossier details");
    }

    handleClose();
  } else {
    toast.error("Message cannot be empty");
  }
};
const fetchUpdatedActionPlans = async () => {
  try {
    const actionPlanResult = await getDossierActionPlan(dossierId);
    if (actionPlanResult.status === 200 && actionPlanResult.data?.actionPlans) {
      setActionPlans(actionPlanResult.data.actionPlans);
    }
  } catch (error) {
    console.error("Error fetching updated dossier action plans", error);
  }
};


  const handleEdit = (index) => {
  const plan = actionPlans[index];


  const combinedMessage =
    plan.plan +
    " " +
    (plan.tagged_list
      ? plan.tagged_list.map((tag) => `@${tag.username}`).join(" ")
      : "");

  setMessage(combinedMessage.trim());
  setTaggedList(plan.tagged_list );
  setEditIndex(index);
  setTimeout(() => setOpen(true), 0);
};

  useEffect(() => {
    if (open && editIndex !== null) {
      const plan = actionPlans[editIndex];
      setTaggedList(plan?.tagged_list || []);
    }
  }, [open, editIndex, actionPlans]);
 
  const handleDelete = async(index) => {
    try {
      const result = await deleteActionPlan(index);
     
      if (result.status === 200) {
        toast.success("Dossier Action Plan deleted successfully");
        setActionPlans((prevActionPlans) =>
          prevActionPlans.filter((plan) => plan.id !== index)
        );
      } else {
        toast.error("Failed to delete dossier action plan");
      }
    } catch (error) {
      toast.error("An error occurred while deleting the dossier action plans");
    }
  };
 
  const handleChange = (e) => {
    const value = e.target.value;
    setMessage(value);
 
    if (value.includes('@')) {
      setShowUserList(true);
      const inputAfterAt = value.split('@').pop();
      const filtered = users.filter(user => user.name.toLowerCase().includes(inputAfterAt.toLowerCase()));
      setFilteredUsers(filtered);
    } else {
      setShowUserList(false);
    }
  };
 
  const handleUserClick = (user) => {
    if (!taggedList.some(tag => tag.user_id === user.id)) {
      setMessage(message.replace(/@\w*$/, `@${user.name}`));
      setTaggedList([...taggedList, { username: user.name, user_id: user.id }]);
    }
    setFilteredUsers([]);
    setShowUserList(false);
  };
  
  const handleUserSelect = (event) => {
    const selectedUserId = event.target.value;
    const user = users.find(user => user.id === selectedUserId);
    if (user) {

      const username = user.name.startsWith('$')
      ? user.email.split('@')[0]  
      : user.name;
      
      const formattedUsername = `${username}`;
      const isAlreadyTagged = taggedList.some(tag => tag.user_id === user.id);

      
      if (!isAlreadyTagged) {
        setMessage(`${message} @${formattedUsername}`);

        setTaggedList([...taggedList, { username: formattedUsername, user_id: user.id }]);
       
      }
      
      setSelectedUser(null);
      setShowUserList(false);
    }
  };
  
  const handleTagRemove = (user_id) => {
    setTaggedList(taggedList.filter(tag => tag.user_id !== user_id));
    setMessage(message.replace(new RegExp(`@${taggedList.find(tag => tag.user_id === user_id).username}`, 'g'), ''));
  };
 
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-GB', options);
 
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
   
    let timeAgo;
    if (seconds < 60) {
      timeAgo = `${seconds} second${seconds === 1 ? '' : 's'} ago`;
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      timeAgo = `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      timeAgo = `${hours} hour${hours === 1 ? '' : 's'} ago`;
    } else if (seconds < 2592000) {
      const days = Math.floor(seconds / 86400);
      timeAgo = `${days} day${days === 1 ? '' : 's'} ago`;
    } else if (seconds < 31536000) {
      const months = Math.floor(seconds / 2592000);
      timeAgo = `${months} month${months === 1 ? '' : 's'} ago`;
    } else {
      const years = Math.floor(seconds / 31536000);
      timeAgo = `${years} year${years === 1 ? '' : 's'} ago`;
    }
    return `${formattedDate} | ${timeAgo}`;
  };
  return (
    <Box sx={{ p: 3, bgcolor: '#ffffff', maxHeight: 'fu', overflowY: 'auto'}}
    >
      <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#00A0B2" }}>
        Action Plans
      </Typography>
      {loading ? (
        <CircularProgress sx={{ color: "#1FAFC2", marginLeft: "8px" }} />
      ) : (
        <>
          <Button
            variant="contained"
            onClick={handleOpen}
            sx={{ mb: 2, backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' } }}
          >
            Add Message
          </Button>
          {actionPlans.map((plan, index) => (
            <Card key={plan.id} sx={{ mb: 2, p: 2, boxShadow: 3}}>
              <CardContent>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: "space-between",  }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', width:"100%" }}>
                    <div > 
                    <Box sx={{width:"10%"}}>
                      <Avatar sx={{ mr: 2, backgroundColor: "#1FAFC2" }}>
                        {typeof plan.username === "string" ? plan.username[0] : ""}
                      </Avatar>
                    </Box>
                    </div>
                    <Box sx={{width:"90%"}}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width:"100%" }}>
                        <Typography style={{ fontWeight: 'bold', marginRight: '3rem', fontSize: '0.95rem' }}>{plan.username}</Typography>
                        <div style={{ display: 'flex', gap: '1rem' }}>
                          <FontAwesomeIcon
                            onClick={() => handleEdit(index)}
                            style={{ cursor: 'pointer' }}
                            icon={faPenToSquare}
                          />
                          <FontAwesomeIcon
                            onClick={() => handleDelete(plan.id)}
                            style={{ cursor: 'pointer', color: "#d9554c" }}
                            icon={faTrash}
                          />
                        </div>
                      </div>
 
                      <Typography variant="body2" color="textSecondary">
                        <b style={{ fontSize: '0.8rem' }}>Last modified: </b>{formatDate(plan.last_modified_at)}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
                  {plan.plan}
                </Typography>
                <Typography sx={{ mb: 2, fontSize: '1rem', fontWeight: 'bold' }}>Tagged Users</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, flexDirection: "row" }}>
                  {plan.tagged_list.map(tag => (
                    <Box key={tag.user_id} sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, marginLeft: "1rem" }}>
                      <Tooltip title={tag.username} arrow>
                        <Avatar sx={{ padding: 2, backgroundColor: "#1FAFC2", cursor: "pointer" }}>
                          { tag.username[0] }
                        </Avatar>
                      </Tooltip>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </Card>
          ))}
        </>
      )}
 
      <Dialog open={open} onClose={handleClose} sx={{ '& .MuiDialog-paper': { width: '600px' } }}>
        <DialogTitle>{editIndex !== null ? "Edit Message" : "Add Message"}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Message"
            variant="outlined"
            value={message}
            onChange={handleChange}
            helperText="Use '@' to tag people"
            multiline
            rows={4}
          />
          {showUserList && (
            <List>
              {filteredUsers.map(user => (
                <ListItem button key={user.id} onClick={() => handleUserClick(user)}>
                  <ListItemText primary={user.name} />
                </ListItem>
              ))}
            </List>
          )}
          <Typography variant="subtitle1" sx={{ mt: 2 }}>Select User:</Typography>
          <FormControl fullWidth>
            <InputLabel>Select User</InputLabel>
            <Select
              value={selectedUser || ''}
              onChange={handleUserSelect}
              label="Select User"
            >
              {
                users
                .filter(user => !user.email.split('@')[0].startsWith("share_"))
                .map(user => (
                  <MenuItem key={user.id} value={user.id}>
                    {user.name.startsWith('$') ? (
                      <>{user.email.split('@')[0]}</>
                    ) : (
                      <>{user.name}</>
                    )}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
          <Typography variant="subtitle1" sx={{ mt: 2 }}>Tagged Users:</Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {taggedList.map(tag => (
              <Button
                key={tag.user_id}
                variant="contained"
                color="primary"
                sx={{ mr: 1, width: 'fit-content' }}
                onClick={() => handleTagRemove(tag.user_id)}
              >
                {tag.username}
                
              </Button>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave} variant="contained" color="primary">Save</Button>
          <Button onClick={handleClose} variant="contained" color="error">Cancel</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
 
export default ActionPlan;